"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ActivityType;
(function (ActivityType) {
    ActivityType["CLIENT_ACTIVITY"] = "CLIENT_ACTIVITY";
    ActivityType["TRAINER_ACTIVITY"] = "TRAINER_ACTIVITY";
    ActivityType["WORKOUT_ACTIVITY"] = "WORKOUT_ACTIVITY";
    ActivityType["BIRTHDAY_NOTIFICATION"] = "BIRTHDAY_NOTIFICATION";
    ActivityType["DELETE_USER"] = "DELETE_USER";
    ActivityType["TRAINER_NOTIFICATION"] = "TRAINER_NOTIFICATION";
    ActivityType["UNLINK_QUESTION"] = "UNLINK_QUESTION";
    ActivityType["UNLINK_NOTIFICATION"] = "UNLINK_NOTIFICATION";
    ActivityType["MARKETPLACE_ACTIVITY"] = "MARKETPLACE_ACTIVITY";
    ActivityType["CALENDAR_NOTE"] = "CALENDAR_NOTE";
})(ActivityType || (ActivityType = {}));
exports.default = ActivityType;
//# sourceMappingURL=ActivityType.js.map